import { Directive, TemplateRef, inject } from '@angular/core';

import { StatusMatrixCellContext } from './status-matrix.model';

/**
 * Optional custom cell renderer for `dmb-status-matrix`. Without it every cell renders a `dmb-progress-bar`.
 *
 * ```html
 * <dmb-status-matrix [rows]="rows">
 *   <ng-template dmbStatusMatrixCell let-cell let-row="row">{{ cell.value }}</ng-template>
 * </dmb-status-matrix>
 * ```
 */
@Directive({ selector: 'ng-template[dmbStatusMatrixCell]' })
export class StatusMatrixCellDirective {
  readonly template = inject<TemplateRef<StatusMatrixCellContext>>(TemplateRef);

  static ngTemplateContextGuard(_dir: StatusMatrixCellDirective, ctx: unknown): ctx is StatusMatrixCellContext {
    return true;
  }
}
